import { jsxs as t, Fragment as e, jsx as r } from "react/jsx-runtime";
const o = () => /* @__PURE__ */ t(e, { children: [
  /* @__PURE__ */ r(
    "path",
    {
      d: "M4.5 4.25C3.32775 4.25 2.36488 5.14647 2.25956 6.29124L11.9849 11.1539L21.6622 5.8754C21.3915 4.93663 20.5259 4.25 19.5 4.25H4.5Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ r(
    "path",
    {
      d: "M4.5 19.75C3.25736 19.75 2.25 18.7426 2.25 17.5V7.96351L11.6646 12.6708C11.8842 12.7806 12.1436 12.776 12.3592 12.6584L21.75 7.53613V17.5C21.75 18.7426 20.7426 19.75 19.5 19.75H4.5Z",
      fill: "currentColor"
    }
  )
] });
export {
  o as default
};
